/**
 * RESPONSIBILITY: put the upcoming events into a moving strip.
 *
 * The moving is the shared Carousel's job and deliberately not repeated here: the rules
 * about when a strip may move are an accessibility contract, and a second copy of them
 * is a second copy to correct.
 */
import { idOf } from '@framework/core';
import type { EventRow } from '@app/sections';
import { EventCard } from './EventCard';
import { Carousel } from '../commons/Carousel';

export interface EventCarouselProps {
  events: EventRow[];
  seconds?: number;
  resumeAfter?: number;
  prevLabel: string;
  nextLabel: string;
  pauseLabel: string;
  playLabel: string;
  dotsLabel?: string;
}

export function EventCarousel({ events, ...rest }: EventCarouselProps) {
  return (
    <Carousel count={events.length} {...rest}>
      {events.map((e) => <EventCard key={idOf(e)} e={e} wide />)}
    </Carousel>
  );
}
